import { Reducer } from "react";

import {
  getTimeReportProjectItemPathId,
  TimeReportProjectItemPath,
  TransformTimeReportProjectItemFunction,
} from "@/data/time-reports";

export type TimeReportEditItemStatus = "idle" | "working" | "success" | "error";

export interface TimeReportEditQueueItem {
  path: TimeReportProjectItemPath;
  pathId: string;
  transform: TransformTimeReportProjectItemFunction;
}

export interface TimeReportEditState {
  queue: TimeReportEditQueueItem[];
  itemsStatus: Record<string, TimeReportEditItemStatus>;
  updatingItemPath?: TimeReportProjectItemPath;
}

export const timeReportEditInitialState: TimeReportEditState = {
  queue: [],
  itemsStatus: {},
};

export type TimeReportEditAction =
  | {
      type: "ENQUEUE_UPDATE";
      path: TimeReportProjectItemPath;
      transform: TransformTimeReportProjectItemFunction;
    }
  | {
      type: "DEQUEUE_UPDATE";
    }
  | {
      type: "CLEAR_UPDATING_ITEM";
      outcome: TimeReportEditItemStatus;
    }
  | {
      type: "CLEAR_ITEM_STATUS";
      pathId: string;
    }
  | {
      type: "CLEAR_QUEUE";
    };

export const timeReportEditReducer: Reducer<TimeReportEditState, TimeReportEditAction> = (state, action) => {
  switch (action.type) {
    case "ENQUEUE_UPDATE":
      return {
        ...state,
        queue: [
          ...state.queue,
          {
            path: action.path,
            pathId: getTimeReportProjectItemPathId(action.path),
            transform: action.transform,
          },
        ],
        itemsStatus: {
          ...state.itemsStatus,
          [getTimeReportProjectItemPathId(action.path)]: "working",
        },
      };

    case "DEQUEUE_UPDATE":
      return {
        ...state,
        queue: state.queue.slice(1),
        updatingItemPath: state.queue[0].path,
      };

    case "CLEAR_UPDATING_ITEM":
      return {
        ...state,
        updatingItemPath: undefined,
        itemsStatus: {
          ...state.itemsStatus,
          [getTimeReportProjectItemPathId(state.updatingItemPath!)]: action.outcome,
        },
      };

    case "CLEAR_ITEM_STATUS": {
      const newItemsStatus = {} as Record<string, TimeReportEditItemStatus>;
      Object.entries(state.itemsStatus).forEach(([itemPathId, status]) => {
        if (itemPathId !== action.pathId && status !== "idle") {
          newItemsStatus[itemPathId] = status;
        }
      });

      return {
        ...state,
        itemsStatus: newItemsStatus,
      };
    }

    case "CLEAR_QUEUE": {
      return {
        ...state,
        queue: [],
        itemsStatus: {},
        updatingItemPath: undefined,
      };
    }

    default:
      return { ...state };
  }
};
